document.addEventListener("click", e => {
  const target = e.target.closest("[data-behavior=disabled]")
  if (target) {
    target.toggleAttribute('disabled')
  }
})
